import React from 'react';
import { Grid } from '@material-ui/core';
import Text from '../Typography/Text';
import { ReactComponent as Coins } from '../../assets/icons/coins.svg';
import { ReactComponent as ArrowGrow } from '../../assets/icons/arrow-growth.svg';
import { ReactComponent as ArrowShrink } from '../../assets/icons/arrow-shrink.svg';

import { formatCurrency } from '../../lib/fmt';

const BalanceCard = (props) => {
  const {
    accountName = '--',
    accountNo = '--',
    tdCashBalance = 0,
    tdLongMarketValue = 0,
    tdShortMarketValue = 0,
  } = props.data;

  return (
    <div
      style={{
        backgroundColor: props.isDragging ? '#2b4066' : '#f3f2ff',
      }}
      className="card"
    >
      <div className="card-info">
        <div className="grd-row nm">
          <div className="grd-cell">
            <Text variant="subtitle2" label={accountNo} />
            <Text mt={8} variant="h2" label={accountName} />
            <div className="mt-30">
              <Text mt={8} variant="h1" label={formatCurrency(tdCashBalance)} />
            </div>
          </div>
          <div className="grd-cell-none">
            <div className="icon-container">
              <Coins />
            </div>
          </div>
        </div>
        <div className="mt-20">
          <Grid container spacing={3}>
            <Grid item sm={12} md={6}>
              <div className="grd-row nm sub-header-icon">
                <div className="grd-cell-none">
                  <ArrowGrow />
                </div>
                <div className="grd-cell">
                  <Text variant="subtitle2" label="Long Market Value" />
                </div>
              </div>
              <Text mt={8} variant="h2" label={formatCurrency(tdLongMarketValue)} />
            </Grid>
            <Grid item sm={12} md={6}>
              <div className="grd-row nm sub-header-icon">
                <div className="grd-cell-none">
                  <ArrowShrink />
                </div>
                <div className="grd-cell">
                  <Text variant="subtitle2" label="Short Market Value" />
                </div>
              </div>
              <Text mt={8} variant="h2" label={formatCurrency(tdShortMarketValue)} />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default BalanceCard;
